if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    document.addEventListener("mouseleave", function(event){
        let lastleaveEvent = localStorage.getItem( "lastExitViewed" );
        if(event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)){
            let date = new Date()
            let month = date.getMonth();
            let day = date.getDate();
           if( !lastleaveEvent || lastleaveEvent != month + "-" + day ){
                let js_singUp_form = document.querySelector( ".lightbox-content a" )
                if( js_singUp_form ){
                    js_singUp_form.click();
                    localStorage.setItem( "lastExitViewed", month + "-" + ( day ) )
                }
           }
        }
    });

            

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
 
    $('#featSpecials_picSlider').slick({
        asNavFor:'#featSpecials_textSlider',
        arrows:true,
        centerMode:true,
        centerPadding:'20%',
        responsive : [
            {
                breakpoint : 991,
                settings: {
                    centerPadding:'15%',
                }
            },
            {
                breakpoint : 767,
                settings: {
                    centerPadding:'4rem',
                    arrows:false
                }
            }
        ]

    });
    
    $('#featSpecials_textSlider').slick({
        asNavFor:'#featSpecials_picSlider',
        arrows:false,
        centerMode:true,
        centerPadding:'20%',
        responsive : [
            {
                breakpoint : 991,
                settings: {
                    centerPadding:'15%',
                }
            },
            {
                breakpoint : 767,
                settings: {
                    centerPadding:'4rem',
                    arrows:false,
                    dots:true,
                    
                }
            }
        ]

    });

})();